import React, { useEffect, useState } from 'react';
import styles from '../Client/ClientMainData/clientMainData.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import formatNumber from '../../utils/formatNumber';
import getDealCard from '../../api/deals/getDealCard';
import getDealCars from '../../api/deals/getDealCars';

// components
import ClientCheck from '../../components/ClientCheck/ClientCheck';
import Loader from '../../components/Loader/Loader';
import NotaryForm from '../../components/NotaryForm/NotaryForm';
import SelectPhoto from '../Client/NewClient/ClientCreate/SelectPhoto/SelectPhoto';
import ClientLink from '../../components/ClientLink/ClientLink';
import AddFileButton from '../../components/AddFileButton/AddFileButton';
import SelectNotaryDealStatuses from '../../components/Selects/SelectNotaryDealStatuses';

import Button from '../../components/Button/Button';
import getDealDocuments from '../../api/deals/getDealDocuments';
import { colors } from '../../constants/colors';
import {
  DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED,
  DEAL_STATUS_WAIRING_REGISTRATION,
  DEAL_STATUS_WAITING_FOR_PAYMENT,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
  PAYMENT_TYPES_CREDIT_CARD,
  PAYMENT_TYPES_CREDIT_INVOICE,
  DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS,
  DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
  DOCUMENT_TYPES_INVOICE,
  DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
  DOCUMENT_TYPES_GRNZ,
  DOCUMENT_TYPES_TECH_PASSPORT,
  BANKS,
  DEAL_STEPS,
  DOCUMENT_TYPES_GUARANTEE_LETTER,
} from '../../constants';
import uploadDocumentToDeal from '../../api/deals/uploadDocumentToDeal';
import editDeal from '../../api/deals/editDeal';
import alert from '../../helpers/alert';
import setStep from '../../api/deals/setStep';
import Input from '../../components/Inputs/Input/Input';
import generateAllowedDocumentsJson from '../../utils/generateAllowedDocumentsJson';
import getCreditAppeal from '../../api/deals/getCreditAppeal';
import sendMarriedDoc from '../../api/creditPlatform/sendMarriedDoc';

const DealNotary = () => {
  const { id } = useParams();
  const [photo, setPhoto] = useState();
  const [uploadPhoto, setUploadPhoto] = useState();
  const [isDisableSelectPhoto, setDisableSelectPhoto] = useState(true);
  const [dealInfo, setDealInfo] = useState([]);
  const [cars, setCars] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deal, setDeal] = useState({});
  const [dealStatus, setDealStatus] = useState(null);
  const [powerOfAttorneyNumber, setPowerOfAttorneyNumber] = useState('');
  const [dealDocuments, setDealDocuments] = useState([]);
  const [showSpoouseConsent, setShowSpoouseConsent] = useState(true);

  const navigateToClient = (id) => {
    navigate(`/notary/clients/${id}/main-data`);
  };

  useEffect(() => {
    setDealStatus({
      label: deal?.status?.title,
      value: deal?.status?.id,
    });
    setPowerOfAttorneyNumber(deal?.power_of_attorney_number);
  }, [deal]);

  const init = () => {
    getDealCard({ id: id })
      .then(async (res) => {
        const dealInfo = [
          {
            label: 'ÐÐ»Ð¸ÐµÐ½Ñ',
            defaultValue: res.data?.client ? `${res.data?.client?.name} ${res.data?.client?.surname}` : '',
            component: (
              <div
                style={{ position: 'absolute', right: '5px', top: '0px' }}
                onClick={() => navigateToClient(res.data?.client?.id)}
              >
                <ClientLink client={'ÐÐ¾ÑÐ¼Ð¾ÑÑÐµÑÑ ÐºÐ°ÑÑÐ¾ÑÐºÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°'} />
              </div>
            ),
          },
          {
            defaultValue: new Date(res.data.createdAt).toLocaleDateString(),
            label: 'ÐÐ°ÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸',
          },
          {
            label: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
            defaultValue: res?.data?.status?.title,
          },
          {
            label: 'Ð¤Ð¾ÑÐ¼Ð° Ð¾Ð¿Ð»Ð°ÑÑ',
            defaultValue: res.data.paymentType?.title,
          },
          {
            label: 'Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ',
            defaultValue: res.data.statusPayment?.title,
          },
          {
            name: 'sum',
            label: 'Ð¡ÑÐ¼Ð¼Ð° ÑÐ´ÐµÐ»ÐºÐ¸, KZT',
            placeholder: 'ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ ÑÐ°ÑÑÐµÑ',
            defaultValue: formatNumber(res.data.sum),
          },
        ];

        const { data: dealDocuments } = await getDealDocuments({ id: id });

        const documents = dealDocuments?.map((doc) => ({
          label: doc?.type?.title,
          component: (
            <a
              href={doc?.url}
              target="_blank"
              rel="noreferrer"
              style={{
                color: colors.cameo,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              Ð¡ÐºÐ°ÑÐ°ÑÑ
              <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8 5.5H10V15.5H8V5.5ZM12 9.5H14V15.5H12V9.5ZM4 11.5H6V15.5H4V11.5ZM12 2.5H2V18.5H16V6.5H12V2.5ZM0 1.492C0 0.944 0.447 0.5 0.999 0.5H13L18 5.5V19.493C18.0009 19.6243 17.976 19.7545 17.9266 19.8762C17.8772 19.9979 17.8043 20.1087 17.7121 20.2022C17.6199 20.2957 17.5101 20.3701 17.3892 20.4212C17.2682 20.4723 17.1383 20.4991 17.007 20.5H0.993C0.730378 20.4982 0.479017 20.3931 0.293218 20.2075C0.107418 20.0219 0.00209465 19.7706 0 19.508V1.492Z"
                  fill="var(--brand-primary)"
                />
              </svg>
            </a>
          ),
        }));

        if (!dealDocuments?.find((doc) => doc?.typeId == DOCUMENT_TYPES_POWER_OF_ATTORNEY)) {
          documents.push({
            labelIcon: 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð½Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð°',
            component: (
              <AddFileButton
                id={'POWER_OF_ATTORNEY'}
                label={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ'}
                onChange={(file) => {
                  setLoading(true);
                  uploadDocumentToDeal({
                    dealId: res?.data?.id,
                    fileTypeId: DOCUMENT_TYPES_POWER_OF_ATTORNEY,
                    file,
                  }).then(() => {
                    // setShowSpoouseConsent(false);
                    if (
                      dealDocuments?.find((doc) => doc?.typeId == DOCUMENT_TYPES_SPOUSE_CONSENT) &&
                      (res?.data?.paymentType?.id == PAYMENT_TYPES_CREDIT_CARD ||
                        res?.data?.paymentType?.id == PAYMENT_TYPES_CREDIT_INVOICE)
                    ) {
                      editDeal({
                        id: res?.data?.id,
                        dealId: res?.data?.id,
                        statusId: DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED,
                      })
                        .then(() => {
                          init();
                        })
                        .finally(() => setLoading(false));
                    } else {
                      setLoading(false);
                      init();
                    }
                  });
                }}
              />
            ),
          });
        }

        if (
          !dealDocuments?.find((doc) => doc?.typeId == DOCUMENT_TYPES_SPOUSE_CONSENT) &&
          (res?.data?.paymentType?.id == PAYMENT_TYPES_CREDIT_INVOICE ||
            res?.data?.paymentType?.id == PAYMENT_TYPES_CREDIT_CARD)
        ) {
          documents.push({
            labelIcon: 'Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾ Ð½Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð¾',
            component: (
              <AddFileButton
                id={'SPOUSE_CONSENT'}
                label={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ'}
                onChange={(file) => {
                  setLoading(true);
                  uploadDocumentToDeal({
                    dealId: res?.data?.id,
                    fileTypeId: DOCUMENT_TYPES_SPOUSE_CONSENT,
                    file,
                  })
                    .then(async () => {
                      init();
                    })
                    .finally(() => setLoading(false));
                }}
              />
            ),
            spouce: true,
          });
        }

        setDealInfo(dealInfo);
        setDocuments(documents);
        setPhoto(res.data?.client?.photo);
        setDeal(res.data);
        setDealDocuments(dealDocuments);
      })
      .then(() => {
        getDealCars({ id: id }).then((res) => {
          const car = res.data.cars[0];
          const carInfo = [
            { label: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ', defaultValue: `${car.mark} ${car.model} (ID ${car.id})` },
            { label: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ', defaultValue: car.complectation.title },
            { label: 'ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°', defaultValue: car.issueYear },
            { label: 'VIN', defaultValue: car.vin },
            { label: 'ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ', defaultValue: 'Kia DOSCAR ÐÐ»Ð¼Ð°ÑÑ' },
            { label: 'Ð¦Ð²ÐµÑ', defaultValue: car.color },
            { label: 'Ð¢Ð¸Ð¿ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ', defaultValue: car.complectation?.engine?.title },
          ];

          setCars(carInfo);
        });
      })
      .catch((error) => {
        console.log(error, '[error]');
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    init();
  }, []);
  const navigate = useNavigate();

  const done = () => {
    alert.success('ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ñ');
    navigate('/notary/deals');
  };

  const saveDeal = async () => {
    if (!dealDocuments?.find((doc) => doc?.typeId === DOCUMENT_TYPES_POWER_OF_ATTORNEY)) {
      return alert.error('ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð½Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð°');
    }

    // if (
    //   !dealDocuments?.find((doc) => doc?.typeId === DOCUMENT_TYPES_SPOUSE_CONSENT) &&
    //   (deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_CARD || deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_INVOICE)
    // ) {
    //   return alert.error('Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾ Ð½Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð¾');
    // }

    let newStatus = null;

    if (deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_CARD || deal?.paymentType?.id === PAYMENT_TYPES_CREDIT_INVOICE) {
      let status = dealDocuments?.find((doc) => doc?.typeId === DOCUMENT_TYPES_SPOUSE_CONSENT)
        ? DEAL_STATUS_WAITING_FOR_REGISTRATION_DOCUMENTS
        : DEAL_STATUS_WAIRING_REGISTRATION;

      newStatus = dealStatus?.value == DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED ? status : dealStatus?.value;
    } else {
      newStatus =
        dealStatus?.value == DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED
          ? DEAL_STATUS_WAIRING_REGISTRATION
          : dealStatus?.value;
    }

    setLoading(true);
    if (dealStatus) {
      const creditAppeals = await getCreditAppeal({ chunkId: deal?.chunkId });
      const chosenBankAppeal = creditAppeals?.data?.appeals?.find((appeal) => appeal?.selected);

      if (chosenBankAppeal?.bank?.id === BANKS.HALYK) {
        setLoading(true);
        return sendMarriedDoc({ appealId: chosenBankAppeal?.id })
          .then(() => {
            editDeal({
              id: deal?.id,
              dealId: deal?.id,
              statusId: DEAL_STATUS_WAITING_FOR_PAYMENT,
              step: DEAL_STEPS.HALYK.WAITING_FOR_PAYMENT,
              power_of_attorney_number: powerOfAttorneyNumber ? powerOfAttorneyNumber : deal?.power_of_attorney_number,
              ...generateAllowedDocumentsJson([
                DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
                DOCUMENT_TYPES_INVOICE,
                DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
                DOCUMENT_TYPES_POWER_OF_ATTORNEY,
                DOCUMENT_TYPES_SPOUSE_CONSENT,
                DOCUMENT_TYPES_GUARANTEE_LETTER,
              ]),
            }).then(() => {
              done();
            });
          })
          .catch(() => {
            alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾');
          })
          .finally(() => {
            setLoading(false);
          });
      }

      await editDeal({
        id: deal?.id,
        dealId: deal?.id,
        statusId: newStatus,
        power_of_attorney_number: powerOfAttorneyNumber ? powerOfAttorneyNumber : deal?.power_of_attorney_number,
        ...generateAllowedDocumentsJson([
          DOCUMENT_TYPES_CLIENT_BANK_DOSCAR_AGREEMENT,
          DOCUMENT_TYPES_INVOICE,
          DOCUMENT_TYPES_APPLICATION_FOR_ADDITIONAL_SERVICES,
          DOCUMENT_TYPES_POWER_OF_ATTORNEY,
          DOCUMENT_TYPES_SPOUSE_CONSENT,
        ]),
      }).then(() => {
        if (dealStatus?.value == DEAL_STATUS_NOTARIAL_DOCUMENTS_UPLOADED) {
          setStep({ dealId: deal?.id, step: 6 }).then(() => {
            done();
          });
        } else {
          done();
        }
      });
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className={styles.wrapper} style={{ paddingBottom: 100 }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <SelectPhoto
                photo={photo}
                setPhoto={setPhoto}
                setUploadPhoto={setUploadPhoto}
                style={{ flex: 1 }}
                disabled={isDisableSelectPhoto}
              />
              <p className={styles.date} style={{ margin: '20px 0' }}>
                ÐÐ»Ð¸ÐµÐ½Ñ Ð·Ð°ÑÐµÐ³Ð¸ÑÑÑÐ¸ÑÐ¾Ð²Ð°Ð½: <span>01.09.2022</span>
              </p>
              <ClientCheck
                list={[
                  {
                    title: 'ÐÐ¾ÑÐ°ÑÐ¸Ð°Ð»ÑÐ½ÑÐµ Ð´Ð¾Ðº-Ñ',
                    status: true,
                    statusLabel: 'Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ñ',
                  },
                ]}
              />
            </div>
            <div className={styles.forms}>
              <NotaryForm title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ'} form={dealInfo} />
              <NotaryForm title={'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ'} form={cars} />
              <NotaryForm
                title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
                form={showSpoouseConsent ? documents : documents?.filter((i) => !i.spouce)}
              />
              <div style={{ marginBottom: '30px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                <SelectNotaryDealStatuses
                  value={dealStatus}
                  onChange={(value) => {
                    setDealStatus(value);
                  }}
                />
                <Input
                  label="ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸"
                  style={{ width: '100%' }}
                  onChange={(value) => {
                    setPowerOfAttorneyNumber(value.target.value);
                  }}
                  defaultValue={powerOfAttorneyNumber}
                />
              </div>

              <Button
                text={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸Ð·Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ'}
                onClick={saveDeal}
                fill
                style={{ width: '280px', marginBottom: '30px' }}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DealNotary;
